import { nestApiPath } from 'constants/url'
import { FC, useEffect, useState } from 'react'
import Link from 'next/link'

import CourseCard from 'components/cards/course-card/course-card'
import usePCWindow from 'hooks/usePCWindow'

import { getAxiosSingle } from 'pages/api/axios'
import { Pathname } from 'constants/data'
import { ScreenSize } from 'constants/media-constanst'

import styles from './lector-courses.module.scss'

interface ILectorCourses {
  lectorId: number
}

const LectorCourses: FC<ILectorCourses> = ({ lectorId }) => {
  const [courses, setCourses] = useState([])
  const isBigPc = usePCWindow(ScreenSize.big)

  useEffect(() => {
    const getData = async () => {
      const courses = await getAxiosSingle(`${nestApiPath}/nmoCourse?LecturId=[${lectorId}]`)
      const coursesResult = courses.status === 404 ? [] : courses
      setCourses(coursesResult.rows)
    }
    getData()
  }, [])

  if (courses.length === 0) return null

  return (
    <>
      <p className={styles.title}>Курсы НМО с участием лектора</p>
      <div className={styles.cardsWrapper}>
        {courses?.map((card: any) => {
          const url = `/${Pathname.NMO_COURSE}/${card.linkTranslation || card.id}`
          return (
            <div key={card.id} className={styles.cardWrapper}>
              <Link href={url} key={card.linkTranslation}>
                <CourseCard {...card} isPc={isBigPc} />
              </Link>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default LectorCourses
